import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

class PlugAuth extends React.Component {
  render () {
    if (this.props.loggedIn || window.localStorage.getItem('login.username')) {
      return <Route {...this.props} />
    }

    return <Redirect to="/login" />
  }
}

const mapStateToProps = (state, props) => ({
  loggedIn: state.login.jwt || false,
  permissions: state.login.permissions || []
})

export default connect(mapStateToProps)(PlugAuth)
